/**
 * 应用角标跟随未读（任务 18c1）。
 *
 * 计数口径单点在 `~/push/badge.badgeCountOf`（非免打扰会话未读之和，与通知过滤同
 * 口径），写入单点在 `applyAppBadge`（0 走 clearAppBadge、失败静默）。本文件只接线。
 * （那两个函数刻意不放在 pushCapability 里：它依赖安装引导文案，会进首屏 bundle。）
 *
 * 接线放 store 层而不是组件里：角标与 UI 是否挂载无关（切到「我的」Tab、开着设置
 * 页时未读照样要更新）。零请求——数据全来自 Worker 已回流的会话行。
 *
 * 订阅故意分两步：selector 只取 `rows` 引用（每帧一次 Object.is，极省），
 * 真正 O(n) 的求和只在 rows 真的换了对象时做一次，并与上次的计数比对后才写角标
 * （会话列表因别的字段变化而重建时不重复调 setAppBadge）。
 */
import { applyAppBadge, badgeCountOf, type BadgeNavigator } from '~/push/badge';
import type { GlobalState, GlobalStore } from './global';

export function connectAppBadge(store: GlobalStore, nav: BadgeNavigator): () => void {
  let last = badgeCountOf(store.get().conversations.rows);
  // 首次：冷启动从 IndexedDB 回流的未读也要立刻上角标（standalone 下尤其明显）
  applyAppBadge(nav, last);
  return store.subscribe(
    (s: GlobalState) => s.conversations.rows,
    (rows) => {
      const next = badgeCountOf(rows);
      if (next === last) return;
      last = next;
      applyAppBadge(nav, next);
    },
  );
}
